import { CodiceAziendaZucchetti, MandatiMago } from 'src/app/model/customer';
import { CartRow } from './../model/CartRow';
import { CmsService } from './../core/services/cms.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TbAuthService } from '@tb/auth';
import { LoginService } from 'src/app/core/services/login.service';
import { RolesService } from '../core/services/roles.service';
import { MatSidenav } from '@angular/material/sidenav';
import { LoadingService } from '../core/services/loading.service';
import { OperationResult } from '@tb/auth';
import { WorkFlowService } from '../core/services/work-flow.service';
import { Account } from '../model/account';
import { MediaMatcher } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { TranslatedVariables } from '../commons/translated-variables';
import { CmsObject } from '../model/cmsobject';
import { CartRowStatus } from '../model/CartRow';
import { SubscriptionService } from '../core/services/subscription.service';
import { ServiceUtilsService } from '../core/services/service-utils.service';
import { ST_Roles, StoreRolesService } from '../core/services/store-role.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MagoWebService } from '../core/services/mago-web.service';
import { MiniStorageService } from '../core/services/mini-storage.service';
import { MagoCloudService } from '../core/services/mago-cloud.service';
import { VerticalSolutionsService } from '../core/services/verticalsolutions.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    isLogged: boolean;
    reason = '';
    isForInternalUse: boolean = true;
    isAdmin: boolean = false;
    showSubAccMenu: boolean = false;
    isDocumentation: boolean = false;
    AccountName = '';
    email = '';
    FullName = '';
    showImage: boolean = false;
    hasAnAssociatedSubscription: boolean = false;
    canChangePassword: boolean = false;
    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;
    @ViewChild('snav') snav: MatSidenav;
    language: string;
    selected = 'language';
    cmsObj: CmsObject[] = [];
    public footercopyright = '';
    public currentYear = '';
    public isWidthMobile = false;
    public isBusinessPartner: boolean = false;
    zucchettiHomeLink: string;
    privacyLink: string;
    legalNotesLink: string;
    authorizationStored;
    authorizationProperties;
    isCASLoggedIn = false;

    constructor(
        private authService: TbAuthService,
        private router: Router,
        private loginService: LoginService,
        public loadingService: LoadingService,
        public messageService: MessageService,
        private subscriptionService: SubscriptionService,
        public workFlow: WorkFlowService,
        private customerService: CustomerService,
        private cmsService: CmsService,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        private translate: TranslateService,
        private storeRoleService: StoreRolesService,
        private gwamRoleService: RolesService,
        public navigateService: NavigateService,
        private magoWebService: MagoWebService,
        private breakpointObserver: BreakpointObserver,
        private miniStorage: MiniStorageService,
        private magoCloudService: MagoCloudService,
        private verticalSolutionService: VerticalSolutionsService
    ) {
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        // controllo affinchè l'utente con il ruolo Internal non possa accedere alla pagina welcome
        if (this.authorizationProperties && window.location.pathname === '/home') {
            this.readRoles();
        }

        this.authService.loggedOut$.subscribe(() => {
            localStorage.clear();
            sessionStorage.clear();
            this.gwamRoleService.clear();
            //svuoto gli oggetti del customer service
            this.customerService.clear();
            this.magoWebService.Clear();
            this.magoCloudService.Clear();
            this.isLogged = false;
            this.isAdmin = false;
            //this.isInternal = false;
        });
    }

    async ngOnInit() {
        this.loginService.currentLoggedCAS.subscribe(
            (res) => {
                this.isCASLoggedIn = res;
                this.isLogged = res;
            },
            (err) => {
                this.isCASLoggedIn = false;
                this.isLogged = false;
            }
        );

        this.breakpointObserver.observe(['(max-width: 900px)']).subscribe((state: BreakpointState) => {
            this.isWidthMobile = state.matches;
        });
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.isLogged = this.authorizationProperties ? true : false;
        if (this.isLogged) {
            this.setSiteLanguage();
            this.gwamRoleService.authorizationStored = this.authorizationStored;
            this.gwamRoleService.authorizationProperties = this.authorizationProperties;
            await this.gwamRoleService.refreshRoles(this.authorizationProperties.accountName);
            this.AccountName = this.authorizationProperties.accountName;
            this.email = this.authorizationProperties.accountEmail;
            this.isAdmin = this.gwamRoleService.hasAdminRole;
            let canContinue = await this.getInfoAccount();
            if (!canContinue) return;
            await this.getInfoSubscription();
            this.showSubAccMenu = this.checkRolesForSubAcc();
        }
        if (
            this.authorizationProperties &&
            this.authorizationProperties.accountName !== '' &&
            this.authorizationProperties.accountName !== undefined
        ) {
            this.miniStorage.get('codiceazienda').subscribe(
                async (r) => {
                    if (r) {
                        if (r == CodiceAziendaZucchetti) {
                            this.verticalSolutionService.currentCodiceAzienda = CodiceAziendaZucchetti;
                            this.storeRoleService.setST_Roles(
                                this.authorizationProperties.accountName,
                                ST_Roles[ST_Roles.ST_ZUCCHETTIACCOUNT].toString()
                            );
                        }
                        await this.storeRoleService.saveSTRolesInSession(this.authorizationProperties.accountName);

                        if (this.storeRoleService.isZucchettiAccount) this.customerService.setZuccchettiCompanyInfo(r);

                        await this.customerService.getCustomerMasterData(
                            this.authorizationProperties.accountEmail,
                            this.authorizationProperties.accountName,
                            'infinity',
                            this.storeRoleService.isZucchettiAccount,
                            r
                        );
                    } else {
                        await this.customerService.getCustomerMasterData(
                            this.authorizationProperties.accountEmail,
                            this.authorizationProperties.accountName,
                            '',
                            this.storeRoleService.isZucchettiAccount,
                            r
                        );
                    }
                },
                (e) => {
                    console.log(`An error occurred while getting codiceazienda ${e}`);
                }
            );

            this.storeRoleService.saveSTRolesInSession(this.authorizationProperties.accountName);
        }

        await this.getCmsObj();
        this.setFooterLink();
        this.loginService.logOff$.subscribe(async () => {
            await this.authService.logoff();
            this.router.navigateByUrl(this.authService.getLoginPageUrl());
            localStorage.clear();
            sessionStorage.clear();
            this.magoWebService.Clear();
            this.magoCloudService.Clear();
            this.customerService.clear();
            this.gwamRoleService.clear();
            this.storeRoleService.Clear();
            this.isLogged = false;
            this.isAdmin = false;
            //this.isInternal = false;
            this.snav?.toggle();
        });
    }

    public checkVisibility() {
        //è visibile se non è internal e non è un business
        let visibility =
            this.customerService.companyInfo?.Mandato != MandatiMago.SILVER &&
            this.customerService.companyInfo?.Mandato != MandatiMago.SILVER;
        return visibility;
    }
    checkRolesForSubAcc() {
        let toSeeAccount = this.isAdmin;
        let toSeeSubscr = this.hasAnAssociatedSubscription;
        let toSeeImpExp = this.gwamRoleService.hasImpExpAdminRole;
        console.log(this.isAdmin + '-' + this.hasAnAssociatedSubscription + '-' + toSeeImpExp);
        return toSeeAccount || toSeeSubscr || toSeeImpExp;
    }

    async onLogoffClick() {
        await this.authService.logoff();
        localStorage.clear();
        sessionStorage.clear();
        this.gwamRoleService.clear();
        //svuoto gli oggetti del customer service
        this.customerService.clear();
        this.magoWebService.Clear();
        this.magoCloudService.Clear();
        this.storeRoleService.Clear();
        this.isLogged = false;
        this.isAdmin = false;
        //this.isInternal = false;
        this.snav?.toggle();
        this.router.navigate(['/home']);
        if (this.isCASLoggedIn) {
            this.logoutMYZ();
        }
    }

    goToYourAccount() {
        const authInfo = this.loginService.getAuthInfoProperties();
        if (authInfo.accountName !== '' && authInfo.accountName !== undefined) {
            this.router.navigate(['/my-profile-global']);
        }
        this.snav.close();
    }

    loginMYZ(): void {
        this.loginService.loginMYZ();
    }

    logoutMYZ(): void {
        this.loginService.logoutMYZ();
        this.isCASLoggedIn = false;
    }

    goToCart() {
        const authInfo = this.loginService.getAuthInfoProperties();
        if (authInfo.accountName !== '' && authInfo.accountName !== undefined) {
            this.router.navigate(['/store/CartProducts']);
        }
        this.snav.close();
    }

    goToHomePage() {
        this.router.navigate(['/home']);
        return;
    }

    isWelcomeComponent() {
        if (window.location.pathname === '/home') {
            return true;
        } else {
            return false;
        }
    }

    readRoles() {
        let internalRoles = this.storeRoleService.IsInternal;
        if (internalRoles) {
            this.navigateService.goToHomePage();
            return;
        }
    }

    goToManagement() {
        this.navigateService.goToManagement();
        this.snav.close();
    }

    goToMyUsers() {
        this.navigateService.goToMyUsers();
        this.snav.close();
    }

    goToProducts() {
        this.navigateService.goToProducts();
        this.snav.close();
    }

    goToMagoUniversity() {
        this.navigateService.goToMagoUniversity();
        this.snav.close();
    }

    goToTechnicalSupport() {
        this.navigateService.goToTechnicalSupport();
        this.snav.close();
    }

    goToMyProfileGlobal() {
        this.navigateService.goToMyProfileGlobal();
        this.snav.close();
    }

    goToDashboard() {
        this.navigateService.goToDashboard();
        this.snav.close();
    }

    goToHelpCenter() {
        this.navigateService.goToHelpCenter();
        this.snav.close();
    }
    goToUsoInterno() {
        this.navigateService.goToUsoInterno();
        this.snav.close();
    }
    goToDocumentation() {
        this.navigateService.goToDocumentation();
        this.snav.close();
    }
    async getInfoSubscription() {
        let opRes = await this.subscriptionService.getSubscriptionsCountToPromise(this.authorizationProperties.accountName);
        this.hasAnAssociatedSubscription = opRes.Content;
    }
    async goToVerticalSolution() {
        this.navigateService.goToVerticalSolution();
        this.snav.close();
    }

    async getInfoAccount() {
        let opRes = await this.loginService.getAccountToPromiseBy(this.authorizationProperties.accountName);
        //Code 32 vuol dire che il token è scaduto
        if (!opRes['Result']) {
            await this.onLogoffClick();
            return false;
        }
        const account: Account = opRes['Content'];
        this.FullName = account.FullName;
        if (opRes && !account.CannotChangePassword) {
            this.canChangePassword = true;
            return true;
        }
        this.canChangePassword = false;
        return true;
    }

    setFooterLink() {
        if (this.language === 'it-IT') {
            this.zucchettiHomeLink = 'https://www.zucchetti.it/website/cms/home.html';
            this.privacyLink = 'https://www.zucchetti.it/it/cms/service/informativa-cookies.html';
            this.legalNotesLink = 'https://www.zucchetti.it/website/cms/note-legali.html';
        } else {
            this.zucchettiHomeLink = 'https://www.zucchetti.com/worldwide/cms/home.html';
            this.privacyLink = 'https://www.zucchetti.com/worldwide/cms/cookies.html';
            this.legalNotesLink = 'https://www.zucchetti.com/worldwide/cms/legal.html';
        }
    }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'footercopyright');
        this.footercopyright = this.cmsObj.find((x) => x.ContentName == 'footercopyright_new').ContentTranslation;
        this.currentYear = new Date().getFullYear().toString();
        this.footercopyright = this.footercopyright.replace('{0}', this.currentYear);
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    doSomething(selectedLanguage: string) {
        switch (selectedLanguage) {
            case 'it-IT':
                this.translate.setDefaultLang('it');
                if (this.authService.isSessionStorage()) {
                    sessionStorage.setItem('selectedLanguage', 'it-IT');
                } else {
                    localStorage.setItem('selectedLanguage', 'it-IT');
                }
                location.reload();
                break;
            case 'en-US':
                this.translate.setDefaultLang('en');
                if (this.authService.isSessionStorage()) {
                    sessionStorage.setItem('selectedLanguage', 'en-US');
                } else {
                    localStorage.setItem('selectedLanguage', 'en-US');
                }
                location.reload();
                break;
            case 'de-DE':
                this.translate.setDefaultLang('de');
                if (this.authService.isSessionStorage()) {
                    sessionStorage.setItem('selectedLanguage', 'de-DE');
                } else {
                    localStorage.setItem('selectedLanguage', 'de-DE');
                }
                location.reload();
            default:
                break;
        }
    }

    setSiteLanguage() {
        if (this.authService.isSessionStorage() && sessionStorage.getItem('selectedLanguage')) {
            this.language = sessionStorage.getItem('selectedLanguage');
        } else if (!this.authService.isSessionStorage() && localStorage.getItem('selectedLanguage')) {
            this.language = localStorage.getItem('selectedLanguage');
        }
        if (!this.language) this.language = 'en-US';
    }
}
